module.exports = __webpack_public_path__ + "static/media/image4.b239ce8b.jpeg";